import { render, staticRenderFns } from "./PageParametersIndex.vue?vue&type=template&id=1d046beb"
import script from "./PageParametersIndex.vue?vue&type=script&lang=js"
export * from "./PageParametersIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports